import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBb-KESpVzY1qYJxFI9V8e7rb_YPz2oyqs",
  authDomain: "vue3-practice-798b3.firebaseapp.com",
  databaseURL: "https://vue3-practice-798b3-default-rtdb.firebaseio.com",
  projectId: "vue3-practice-798b3",
  storageBucket: "vue3-practice-798b3.appspot.com",
  messagingSenderId: "541537983234",
  appId: "1:541537983234:web:e1b537801d5efbcf0fc01b",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
